// src/components/admin/BlockUserModal.jsx
import React from "react";
import { BsX, BsLock, BsUnlock } from "react-icons/bs";
import { useMemberStore } from "../../store/memberStore";

const BlockUserModal = ({
  isBlocked,
  isOpen,
  onClose,
  member,
  onRequest = () => console.log("Requête après close Modal."),
}) => {
  const { blockUser, unblockUser, actionLoading } = useMemberStore();

  const handleAction = async () => {
    try {
      if (isBlocked) {
        await unblockUser(member.id);
      } else {
        await blockUser(member.id);
      }
      onRequest();

      onClose(); // Fermer le modal après succès
    } catch (error) {
      // L'erreur est déjà gérée dans le store
    }
  };

  if (!isOpen || !member) return null;

  // const isBlocked = !member.is_active;
  console.log({ isBlocked });

  const actionText = isBlocked ? "Débloquer" : "Bloquer";
  const confirmText = isBlocked
    ? "débloquer cet utilisateur"
    : "bloquer cet utilisateur";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white w-full max-w-md">
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <div>
            <h2 className="font-poppins font-semibold text-[18px] text-title">
              {actionText} l'utilisateur
            </h2>
            <p className="font-nunito text-[14px] text-text mt-1">
              {member.prenom} {member.nom}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 transition-colors"
            disabled={actionLoading}
          >
            <BsX size={24} />
          </button>
        </div>

        <div className="p-6">
          <div className="flex items-center justify-center mb-4">
            <div
              className={`p-3 ${isBlocked ? "bg-red-100" : "bg-yellow-100"}`}
            >
              {!isBlocked ? (
                <BsLock size={32} className="text-red-600" />
              ) : (
                <BsUnlock size={32} className="text-yellow-600" />
              )}
            </div>
          </div>

          <p className="text-center font-nunito text-[14px] text-text mb-2">
            Êtes-vous sûr de vouloir {confirmText} ?
          </p>

          {!isBlocked && (
            <p className="text-center font-nunito text-[14px] text-text text-sm mb-4">
              L'utilisateur ne pourra plus se connecter à son compte.
            </p>
          )}

          <div className="flex justify-end gap-3">
            <button
              onClick={onClose}
              disabled={actionLoading}
              className="px-4 py-2 text-gray-600 border border-gray-300 hover:bg-gray-50 transition-colors font-nunito font-semibold text-[14px]"
            >
              Annuler
            </button>
            <button
              onClick={handleAction}
              disabled={actionLoading}
              className={`px-4 py-2 text-white transition-colors flex items-center gap-2 font-nunito font-semibold text-[14px] ${
                isBlocked
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-red-600 hover:bg-red-700"
              } disabled:opacity-50`}
            >
              {actionLoading && (
                <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></div>
              )}
              {actionText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockUserModal;